import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass, ref } from "vue";
import helpImg from "@/resources/help-img.svg";
import StickyNotePopup from "./stickynote.vue";

type Props = {
	popupTitle: string
	subheader?: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'popup',
  props: {
    popupTitle: {},
    subheader: {}
  },
  setup(__props: any, { expose: __expose }) {
  __expose();

const props = __props;


const showStickyNote = ref(false);

const closeStickyNote = ()=>{
	showStickyNote.value = false;
};


const __returned__ = { props, showStickyNote, closeStickyNote, normalizeClass, ref, get helpImg() { return helpImg }, StickyNotePopup }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})